import React from 'react';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import { bindActionCreators } from 'redux';
import { TextField, Grid } from '@material-ui/core';
import axiosI from '../../../../Service/service';
import { validateEmail, ValidateName, validateUserName } from '../../../../Helper/Validations';
import {updateEmail, updateUserName, updateName, updatePhone} from '../../../../Actions/myAccountAction';
import * as constants from '../../../../Constants';

class EditProfile extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: props.user.AppUser.FirstName,
                userName: props.user.AppUser.UserName,
                email: props.user.AppUser.Email,
                phoneNo: props.user.AppUser.PhoneNo,
            },
            editMode:"",
            suggestions: [],
            usernameErrorMessage: '',
            emailErrorMessage: '',
            phoneNoErrorMessage: '',
            showSuggestions: false,
            emailError: false,
            phoneNoError: false,
            nameError:"",
        };
    }

    textChange = (e) => {
        let {formData} = this.state;
        let {id,value} = e.target;
        if(id === "userName") {
            if(!value.includes('@')) {
                value = `@${value}`;
            }
        }
        formData[id] = value;
        this.setState({formData});
    };

    selectSuggestion = (value) => {
        let {formData} = this.state;
        formData['userName'] = value;

        this.setState({
            formData,
            showSuggestions: false,
            suggestions: [],
        });
    };

    onEdit = (e) => {
        let editMode

        editMode = e.target.id
        this.setState({
            editMode
        });
    };

    onClose = () => {
        this.setState({
            editMode:"",
            showSuggestions:false,
            emailError:false,
            phoneNoError:false,
            nameError:""
        });
    };

    updateName = () => {
        let data = {
            FieldName: 'Name',
            FieldValue: this.state.formData['name'],
            UserId: this.props.user.AppUser.UserId
        };
        const newName = this.state.formData['name'];
        let response = ValidateName(this.state.formData['name']);
        if(response === "") {
            axiosI.post(constants.API.updateUserInfoApi, data).then((response) => {
                if (response.data.results.ResponseCode) {
                    this.onClose();
                    this.props.toggleAlert();
                    this.props.updateState("alertMessage","Name updated successfully");
                    this.props.updateName(newName);
                    this.setState({ nameError: "" });
                }
                else {
                    this.setState({ nameError: "Please enter valid name" });
                }

            }).catch((err) => {
                console.log(err);
            });
        }
        else {
            this.setState({
                nameError: response
            });
        }
    };

    updateUserName = () => {
        let {suggestions, showSuggestions, usernameErrorMessage, formData } = this.state;
        let userName = formData['userName'].replace('@','');
        let isValidated = validateUserName(userName);
        if (isValidated === "") {
            let data = {
                ContactNo: this.props.user.AppUser.PhoneNo ? this.props.user.AppUser.PhoneNo : "",
                EmailId: this.props.user.AppUser.Email,
                Name: this.props.user.AppUser.FirstName,
                Username: formData['userName'].replace('@','')
            };
            axiosI.post(constants.API.verifyAccountUsernameApi, data).then((response) => {
                if (!response.data.results.ResponseCode) {
                    usernameErrorMessage = "UserName is already used. Avaliable usernames are :";
                    suggestions = response.data.results.Suggestions;
                    showSuggestions = true;
                }
                else {
                    let userNameUpdateData = {
                        FieldName: 'Username',
                        FieldValue: this.state.formData['userName'].replace('@',''),
                        UserId: this.props.user.AppUser.UserId
                    };
                    const newUserName = this.state.formData['userName'].replace('@','');
                    axiosI.post(constants.API.updateUserInfoApi, userNameUpdateData).then((response) => {
                        if (response.data.results.ResponseCode) {
                            this.onClose();
                            this.props.toggleAlert();
                            this.props.updateUserName(newUserName);
                            this.props.updateState("alertMessage","Username updated successfully. ")
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
                this.setState({showSuggestions, suggestions, usernameErrorMessage });
            }).catch((err) => {
                console.log(err);
            });
        }
        else {
            showSuggestions = true;
            usernameErrorMessage = isValidated;
        }
        this.setState({suggestions, showSuggestions, usernameErrorMessage});
    };

    updateEmail = () => {
        let { emailError, emailErrorMessage, formData } = this.state;
        let isEmailValidated = validateEmail(formData['email']);

        if (isEmailValidated === "") {
            axiosI.get(`${constants.API.verifyAccountEmailApi}/${formData['email']}`).then((response) => {
                emailError = !response.data.results.ResponseCode;
                emailErrorMessage = "Email has already been used.";
                if (response.data.results.ResponseCode) {
                    let emailUpdateData = {
                        FieldName: 'Email',
                        FieldValue: this.state.formData['email'],
                        UserId: this.props.user.AppUser.UserId
                    };
                    const newEmail = this.state.formData['email'];
                    axiosI.post(constants.API.updateUserInfoApi, emailUpdateData).then((response) => {
                        if (response.data.results.ResponseCode) {
                            this.onClose();
                            this.props.toggleAlert();
                            this.props.updateEmail(newEmail);
                            this.props.updateState("alertMessage","Email updated successfully.");
                            this.setState({formData});
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
                this.setState({ emailError, emailErrorMessage });
            }).catch((err) => {
                console.log(err);
            })
        }
        else {
            emailError = true;
            emailErrorMessage = isEmailValidated;
            this.setState({emailError, emailErrorMessage});
        }
    };

    updatePhoneNo = () => {
        let { phoneNoError, phoneNoErrorMessage, formData } = this.state;
      let phoneNo=formData['phoneNo'].replace(/\D/g,'');
            axiosI.get(`${constants.API.verifyAccountPhonenumberApi}/${phoneNo.toString()}`).then((response) => {
                if (response.data.results.ResponseCode) {
                    let phoneNoData = {
                        FieldName: 'Phonenumber',
                        FieldValue: phoneNo,
                        UserId: this.props.user.AppUser.UserId
                    };
                    const newPhone = this.state.formData['phoneNo'].replace(/\D/g,'');;
                    axiosI.post(constants.API.updateUserInfoApi, phoneNoData).then((response) => {
                        if (response.data.results.ResponseCode) {
                            this.onClose();
                            this.props.toggleAlert();
                            this.props.updatePhone(newPhone);
                            this.props.updateState("alertMessage","Phone Number updated.");
                            phoneNoError = false;
                        }
                        else {
                            phoneNoErrorMessage = 'Phone Number is invalid.';
                            phoneNoError = true
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
                else {
                    phoneNoErrorMessage = 'Phone Number already exists.';
                    phoneNoError = true
                }
                this.setState({phoneNoErrorMessage, phoneNoError });
            }).catch((err) => {
                console.log(err);
            })
        }
        // else {
        //     phoneNoErrorMessage = 'Invalid phone number.';
        //     phoneNoError = true;
        //     this.setState({phoneNoErrorMessage, phoneNoError});
        // }

    render() {
        const { showSuggestions, usernameErrorMessage, suggestions, emailError,
            emailErrorMessage, phoneNoError, phoneNoErrorMessage, editMode } = this.state;
        const { userName, email, phoneNo } = this.state.formData;
        return (
            <React.Fragment>
                <div className="control-wrapper">
                    {/*{*/}
                        {/*editMode !== "name" ?*/}
                            {/*<div className="display-wrapper">*/}
                                {/*<Grid container spacing={24}>*/}
                                    {/*<Grid item sm={8} xs={9}>*/}
                                        {/*<div className="display-value">*/}
                                            {/*<span>*/}
                                                {/*<i className="fa fa-user"/>*/}
                                            {/*</span>*/}
                                            {/*{name}*/}
                                        {/*</div>*/}
                                    {/*</Grid>*/}
                                    {/*<Grid item sm={4} xs={3}>*/}
                                        {/*<span className="fa fa-2x fa-pencil editProfile" id="name" onClick={this.onEdit}/>*/}
                                    {/*</Grid>*/}
                                {/*</Grid>*/}
                            {/*</div>*/}
                            {/*:*/}
                                {/*<Grid container spacing={24}>*/}
                                    {/*<Grid item sm={6} xs={9}>*/}
                                        {/*<TextField*/}
                                            {/*id="name"*/}
                                            {/*margin="normal"*/}
                                            {/*className="editprofile-text-field"*/}
                                            {/*inputProps={{className: "editprofile-text-field"}}*/}
                                            {/*value={name}*/}
                                            {/*onChange={this.textChange}*/}
                                            {/*autoFocus={true}*/}
                                            {/*required*/}
                                        {/*/>*/}
                                    {/*</Grid>*/}
                                    {/*<Grid item sm={6} xs={3}>*/}
                                        {/*<span className="editProfile-textField">*/}
                                            {/*<span id="name" onClick={this.updateName} className="update-cancel-btn">*/}
                                                {/*<i className="fa fa-edit"/>*/}
                                            {/*</span>*/}
                                            {/*<span id="name" onClick={this.onClose} className="update-cancel-btn">*/}
                                                {/*<img src={require('../../../../images/Delete_Close@3x.png')} className="cancel-btn"/>*/}
                                            {/*</span>*/}
                                        {/*</span>*/}
                                    {/*</Grid>*/}
                                    {/*{name.length === 0 &&*/}
                                    {/*<Grid item sm={2}>*/}
                                        {/*<span style={{color: 'red'}}>Please Enter Name.</span>*/}
                                    {/*</Grid>}*/}
                                    {/*{nameError &&*/}
                                    {/*<span style={{color: 'red'}}>{nameError}</span>}*/}
                                {/*</Grid>*/}
                        {/*}*/}
                        {
                        editMode !== "userName" ?
                            <div className="display-wrapper">
                                <Grid container spacing={24}>
                                    <Grid item sm={8} xs={9}>
                                        <div className="display-value">
                                            <span>
                                                <i className="fa fa-user"/>
                                            </span>
                                            {userName.includes('@') ? userName : `@${userName}`}
                                        </div>
                                    </Grid>
                                    <Grid item sm={4} xs={3}>
                                       <span className="fa fa-2x fa-pencil editProfile" id="userName" onClick={this.onEdit}/>
                                    </Grid>
                                </Grid>
                            </div>
                            :
                                <Grid container spacing={24}>
                                    <Grid item sm={6} xs={9}>
                                        <TextField
                                            id="userName"
                                            margin="normal"
                                            className="editprofile-text-field"
                                            inputProps={{className: "editprofile-text-field"}}
                                            value={userName}
                                            onChange={this.textChange}
                                            autoFocus={true}
                                            required
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={3}>
                                        <span className="editProfile-textField">
                                            <span id="userName" onClick={this.updateUserName} className="update-cancel-btn">
                                                <i className="fa fa-edit"/>
                                            </span>
                                            <span id="userName" onClick={this.onClose} className="update-cancel-btn">
                                                <img src={require('../../../../images/Delete_Close@3x.png')} className="cancel-btn"/>
                                            </span>
                                        </span>
                                    </Grid>
                                    {/*<Grid item sm={12}>*/}
                                        {
                                        showSuggestions &&
                                        <React.Fragment>
                                            <p style={{color: 'red'}}>{usernameErrorMessage}</p>
                                            {
                                                suggestions &&
                                                <span style={{display: 'inline-flex'}}>
                                                    {suggestions.map((value) => {
                                                        return <p style={{padding: '5px'}} onClick={() => {
                                                            this.selectSuggestion(value)
                                                        }}>{`@${value}`}</p>
                                                    })
                                                    }
                                                </span>
                                            }
                                        </React.Fragment>
                                }
                                    {/*</Grid>*/}
                                </Grid>

                    }
                    {
                        editMode !== "email" ?
                            <div className="display-wrapper">
                                <Grid container spacing={24}>
                                <Grid item sm={8} xs={9}>
                                    <div className="display-value">
                                        <span style={{paddingRight:'6px'}}>
                                            <i className="fa fa-envelope"/>
                                        </span>
                                        {email}
                                    </div>
                                </Grid>
                                <Grid item sm={4} xs={3}>
                                    <span className="fa fa-2x fa-pencil editProfile" id="email" onClick={this.onEdit}/>
                                </Grid>
                                </Grid>
                            </div>
                            :
                                <Grid container spacing={20}>
                                    <Grid item sm={6} xs={9}>
                                        <TextField
                                            id="email"
                                            type='email'
                                            margin="normal"
                                            className="editprofile-text-field"
                                            inputProps={{className: "editprofile-text-field"}}
                                            value={email}
                                            onChange={this.textChange}
                                            autoFocus={true}
                                            required
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={3}>
                                        <span className="editProfile-textField">
                                            <span id="email" onClick={this.updateEmail} className="update-cancel-btn">
                                                <i className="fa fa-edit" style={{fontSize:'27px'}}/>
                                            </span>
                                            <span id="email" onClick={this.onClose} className="update-cancel-btn">
                                                <img src={require('../../../../images/Delete_Close@3x.png')} className="cancel-btn"/></span>
                                        </span>
                                    </Grid>
                                    {emailError &&
                                    <span style={{color: 'red'}}>{emailErrorMessage}</span>}
                                </Grid>
                            }
                            {
                        editMode !== "phoneNo" ?
                            <div className="display-wrapper">
                                <Grid container spacing={24}>
                                   <Grid item sm={8} xs={9}>
                                       <div className="display-value">
                                            <span style={{paddingRight: '11px', paddingLeft: '6px'}}>
                                                <i className="fa fa-mobile"/>
                                            </span>{phoneNo ? phoneNo : 'Phone No'}
                                       </div>
                                   </Grid>
                                   <Grid item sm={4} xs={3}>
                                        <span className="fa fa-2x fa-pencil editProfile" id="phoneNo" onClick={this.onEdit}/>
                                   </Grid>
                                </Grid>
                            </div>
                            :
                            <Grid container spacing={24}>
                                <Grid item sm={6} xs={9}>
                                {/*<TextField*/}
                                {/*className={classes.textField}*/}
                                {/*inputProps={{className: classes.inputText}}*/}
                                {/*autoFocus={true}*/}
                                {/*>*/}
                                    <MaskedInput
                                      mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                      className="form-control editprofile-text-field"
                                      guide={false}
                                      showMask={false}
                                      name={'PhoneNo'}
                                      id={'phoneNo'}
                                      value={phoneNo}
                                      onChange={this.textChange}
                                    />
                                {/*</TextField>*/}
                                </Grid>
                                <Grid item sm={6} xs={3}>
                                    <span className="editProfile-textField">
                                        <span id="phoneNo" onClick={this.updatePhoneNo} className="update-cancel-btn">
                                            <i className="fa fa-edit"/>
                                        </span>
                                        <span id="phoneNo" onClick={this.onClose} className="update-cancel-btn"><img src={require('../../../../images/Delete_Close@3x.png')} className="cancel-btn"/></span>
                                    </span>
                                </Grid>
                                {phoneNoError && <span  style={{color: 'red'}}>{phoneNoErrorMessage}</span>}
                            </Grid>
                        }
                    </div>
            </React.Fragment>
        )
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateEmail,
        updateUserName,
        updateName,
        updatePhone
    },dispatch)
};

export default connect(null, matchDispatchToProps)(EditProfile);
